import { Injectable } from '@angular/core';
import { WalkthroughObservationModel } from 'src/app/model/observation/walkthrough-details.model';
import { WalkthroughApi } from '../../api/walkthrough.api';

@Injectable()
export class WalkthroughObservationService {

  constructor(private walkthroughApi: WalkthroughApi) { }

  getObservationDetails = (userId: string, observationId: string) =>
    this.walkthroughApi.getObservationDetails(userId, observationId);

  createWalkthrough = (observation: WalkthroughObservationModel) =>
    this.walkthroughApi.createWalkthrough(observation);

  submitWalkthrough = (observationId: string) =>
    this.walkthroughApi.submitWalkthrough(observationId);
}
